import { createFileRoute } from '@tanstack/react-router'

import { dashboardSearchSchema } from '@/features/dashboard/dashboard-search'
import { DashboardScreen } from '@/features/dashboard/dashboard-screen'

/** What the team appraised and won over a date range; the range preset is in the address. */
export const Route = createFileRoute('/_app/_org/dashboard')({
  validateSearch: dashboardSearchSchema,
  component: DashboardScreen,
})
